import { render, staticRenderFns } from "./BankAccountDetails.vue?vue&type=template&id=be1a337c&scoped=true"
import script from "./BankAccountDetails.vue?vue&type=script&lang=js"
export * from "./BankAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./BankAccountDetails.vue?vue&type=style&index=0&id=be1a337c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1a337c",
  null
  
)

export default component.exports